export default {
  rollover: {
    title: 'Rollover',
    detailsTitle: 'Detalles de Rollover',
    all: 'Todos',
    allStats: 'Todos los estados',
    select: 'Seleccionar',
    rolloverType: 'Tipo de rollover',
    amount: 'Importe',
    source: 'Origen',
    wallet: 'Cartera',
    current: 'Actual',
    wagered: 'Apostado',
    required: 'Requerido',
    progress: 'Progreso',
    loading: 'Cargando...',
    noData: 'Sin datos',
    noMoreData: 'No hay más datos',
    state: 'Estado',
    type: 'Tipo',
    createdOn: 'Creado el',
    wageringRequirement: 'Requisito de apuesta',
    currency: 'Moneda',
    wagerRequired: 'Apuesta requerida',
    wagerCompleted: 'Apuesta completada',
    cash: 'Efectivo',
    bonus: 'Bono',
  },
};
